import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenant } from '@/providers/TenantProvider';

const DISMISS_KEY = 'tenant.banner.dismissed';

export function TenantContextBanner() {
  const { t } = useTranslation();
  const { isElevated, activeTenant, setActiveTenant } = useTenant();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1');

  useEffect(() => {
    setDismissed(sessionStorage.getItem(DISMISS_KEY) === '1');
  }, [activeTenant?.id]);

  if (!isElevated || !activeTenant || dismissed) return null;

  return (
    <div
      className="border-b px-6 py-2 text-sm"
      style={{
        background: 'color-mix(in srgb, var(--warning) 12%, var(--card))',
        borderColor: 'var(--warning)',
      }}
      role="status"
    >
      <div className="flex items-center justify-between gap-4">
        <span>{t('tenant.banner.viewing', { name: activeTenant.display_name })}</span>
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="text-primary underline"
            onClick={() => setActiveTenant(activeTenant.id)}
          >
            {t('tenant.banner.switch')}
          </button>
          <button
            type="button"
            className="flex h-6 w-6 items-center justify-center rounded p-1 text-muted-foreground hover:bg-muted/60"
            onClick={() => {
              sessionStorage.setItem(DISMISS_KEY, '1');
              setDismissed(true);
            }}
            aria-label={t('tenant.banner.dismiss')}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
